import { useQuery } from '@tanstack/react-query';

import getConversationHistory from '../api/getConversationHistory';

const useConversationHistory = (rfqId?: number) => {
  return useQuery({
    queryKey: ['conversation-history', rfqId],
    queryFn: () => getConversationHistory(rfqId as number),
    enabled: !!rfqId,
    staleTime: 0,
    refetchOnMount: 'always'
  });
};

export default useConversationHistory;
